import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import loadable from "@loadable/component";
import withErrorHandling from "./hoc/withErrorHandling.tsx";
import { ROUTES } from "./constants/index.ts";

const ChatBotWidget = loadable(() =>
  import("./module/chatBotWidget/index.tsx")
);
const ChatBotWidgetV2 = loadable(() =>
  import("./module/v2ChatBotWidget/index.tsx")
);
const ChatBotWidgetV2Link = loadable(() =>
  import("./module/v2ChatBotWidgetLink/index.tsx")
);

const RedirectWithQuery = ({ to }) => {
  const location = useLocation();
  const search = location.search;

  return <Navigate to={`${to}${search}`} replace />;
};

const Main = () => {
  return (
    <Router future={{ v7_startTransition: true }}>
      <Routes>
        <Route path={`/${ROUTES.v2}`} element={<ChatBotWidgetV2 />} />
        <Route
          path={`/${ROUTES.sms}/:bot_id/:conv_id/:message_id?`}
          element={<ChatBotWidgetV2Link />}
        />
        <Route
          path={`/${ROUTES.web}/:bot_id/:conv_id/:message_id?`}
          element={<ChatBotWidgetV2Link />}
        />
        <Route
          path={`/${ROUTES.web}/:bot_id`}
          element={<ChatBotWidgetV2Link independentStarterBot={true} />}
        />
        <Route
          path={`/${ROUTES.whatsapp}/:bot_id/:conv_id/:message_id?`}
          element={<ChatBotWidgetV2Link />}
        />
        <Route path="/" element={<ChatBotWidget />} />
        <Route path="/index.html" element={<RedirectWithQuery to="/" />} />
      </Routes>
      {/* NOTE: update useChat hook to check for new route */}
    </Router>
  );
};

export default withErrorHandling(Main);
